export default __webpack_public_path__ + "static/media/person_bubble_rectangle_on_circle.469e40c8.png";